<template>
  <div class="ApiList container">
      <div v-for="(items, indexs) in listData" :key="indexs" class="api cursor">
        <div class="api-title">
            <img class="title-icon" :src="items.imgurl"/>
            <div class="title-introduce">
                <p>{{items.title}}</p>
                <p>{{items.content1}}</p>
                <p>{{items.content2}}</p>
            </div>
        </div>
        <div class="companey">
            <div v-for="(item, index) in items.datafrom" :key="index" class="companey-detail cursor">
                <router-link :to="item.linkto" class="companey-detail-link cursor">
                    <div class="logo"><img v-if="item.logo" :src="item.logo"/></div>
                    <div class="introduce">{{item.introduce}}</div>
                </router-link>
                <div v-if="index === 0 || index === 2" class="right-line"></div>
            </div>
            <div v-if="items.datafrom.length < 4" class="companey-detail">
                <div class="waiting">敬请期待…</div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
/**
 * 首页API导航列
 *
 * @requires Home.vue
 * @author liguojie
 */
import navApi from '@/http/api/v1/apiNavList'
export default {
  components: {
  },
  name: 'HomeApiList',
  data () {
    return {
      listData: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () { // 获取数据
      this.listData = navApi.getNaveData()
    }
  }
}
</script>

<style scoped lang="scss">
.ApiList{
    a{
      text-decoration: none;
    }
    .api{
        margin-bottom: 60px;
        height:120px;
        background:rgba(255,255,255,1);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-shadow:0px 6px 20px 0px rgba(226,226,232,1);
        .api-title{
            width: 270px;
            height: 120px;
            background: url(../assets/images/api-article.jpg) center center;
            background-size: 100% 100%;
            padding: 30px 20px 21px 30px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .title-icon{
                width: 30px;
                height: 38px;
                margin-right: 15px;
            }
            .title-introduce{
                width: 170px;
                color:rgba(255,255,255,1);
            }
            .title-introduce :nth-child(1){
                margin-bottom: 7px;
            }
            .title-introduce :nth-child(2){
                margin-bottom: 5px;
                font-size:12px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(255,255,255,1);
            }
            .title-introduce :nth-child(3){
                font-size:12px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(255,255,255,1);
            }
        }
        .companey{
            width: 700px;
            height: 120px;
            padding: 15px 30px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            align-items: flex-start;
            .companey-detail{
                height: 45px;
                line-height: 45px;
                box-sizing: border-box;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                position: relative;
                .companey-detail-link{
                    height: 45px;
                    line-height: 45px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    position: relative;
                }
                .right-line{
                    position: absolute;
                    right: 0;
                    top: 7px;
                    width:1px;
                    height:30px;
                    background:rgba(243,243,248,1);
                }
                .waiting{
                    height:20px;
                    font-size:14px;
                    font-family:PingFangSC-Regular;
                    font-weight:400;
                    color:rgba(194,194,201,1);
                    line-height:20px;
                }
                .logo{
                    width: 121px;
                    height: 45px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    img{
                        max-width: 110px;
                        max-height: 30px;
                    }
                }
                .introduce{
                    font-size:12px;
                    font-family:PingFangSC-Regular;
                    font-weight:400;
                    color:rgba(136,136,146,1);
                }
            }
            .companey-detail:nth-child(1), .companey-detail:nth-child(3){
                width: 310px;
                // border-right: 1px solid #F3F3F8;
            }
            .companey-detail:nth-child(1), .companey-detail:nth-child(2){
                border-bottom: 1px solid #F3F3F8;
            }
            .companey-detail:nth-child(2), .companey-detail:nth-child(4){
                width: 329px;
                padding-left: 28px;
            }
        }
    }
    .api:last-child{
        margin-bottom: 0;
    }
}
</style>
